<button mat-icon-button [ngStyle]="{ color: buttonColor }" class="satisfacao-picker-button">
  <mat-icon matTooltip="{{ tooltip }}" style="font-size: 30px">{{ matIcon }}</mat-icon>
</button>
